import { Reserve } from "../Model/Reserve";

export const decimalRescale = (reserve: Reserve) => {
  return 10 ** reserve.decimals;
};
